import 'custom-event-polyfill';

import {
  BomColorChangeEvent,
  BomOptionsErrorEvent,
  BomOptionsEventTargetDesignLater,
  BomOptionsLoadingCompletedEvent,
  BomOptionsSavingCompletedEvent,
  BomOptionsSavingStartEvent,
  BomOptionsValidationPassedEvent,
} from './bom/constants';
import { PARAMETER_PACKAGESIGNATURE, PackageSignatureBomOptions, configuratorStep } from './main/constants';
import {
  addToCart,
  initializeBomOptionsAsync,
  initializeMainAsync,
  parametersFormat,
  parametersValidation,
} from './main/logics';
import { dispatchBomOptionsSavingCompletedEvent, dispatchBomOptionsSavingStartEvent } from './bom/logics';
import { initializeParameters, setCurrentStep, showWaitingCover } from './main/actions';

import BomOptionsApp from './BomOptionsApp';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom/client';
import configureStore from './configureStore';
import { createBrowserHistory } from 'history';
import { unregister } from './registerServiceWorker';

// Create browser history to use in the Redux store
const history = createBrowserHistory({});

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history, {});

unregister();

const render = (rootId, params) => {
  const InvalidParametersError =
    "ERROR: Invalid parameters were passed in when calling 'window.promoStudio.bomOptions.render()'.";
  if (!!params && typeof params === 'object') {
    const parameters = parametersFormat(params);
    const valid = parametersValidation(parameters);
    if (valid.success) {
      parameters[PARAMETER_PACKAGESIGNATURE] = PackageSignatureBomOptions;
      store.dispatch(initializeParameters(parameters));
      store.dispatch(initializeMainAsync(parameters));
    } else {
      console.error(`${InvalidParametersError} - ${valid.message}`);
      store.dispatch(setCurrentStep(configuratorStep.error));
    }
  } else {
    console.error(InvalidParametersError);
    store.dispatch(setCurrentStep(configuratorStep.error));
  }

  const root = ReactDOM.createRoot(document.getElementById(rootId));
  root.render(
    <Provider store={store}>
      <BomOptionsApp />
    </Provider>
  );
};

const renderWithFullData = (rootId, token, params, bomOptionsFullData) => {
  if (!!token && typeof token === 'object') {
    const { aplToken, aplTokenTimeout } = token;
    sessionStorage.setItem('apl_token', aplToken);
    sessionStorage.setItem('apl_token_timeout', aplTokenTimeout);
  }

  const InvalidParametersError =
    "ERROR: Invalid parameters were passed in when calling 'window.promoStudio.bomOptions.renderWithFullData()'.";
  if (!!params && typeof params === 'object') {
    const parameters = parametersFormat(params);
    const valid = parametersValidation(parameters);
    if (valid.success) {
      parameters[PARAMETER_PACKAGESIGNATURE] = PackageSignatureBomOptions;
      store.dispatch(initializeParameters(parameters));
      if (!!token && typeof token === 'object') {
        store.dispatch(initializeBomOptionsAsync(parameters, bomOptionsFullData));
      } else {
        store.dispatch(initializeMainAsync(parameters, bomOptionsFullData));
      }
    } else {
      console.error(`${InvalidParametersError} - ${valid.message}`);
      store.dispatch(setCurrentStep(configuratorStep.error));
    }
  } else {
    console.error(InvalidParametersError);
    store.dispatch(setCurrentStep(configuratorStep.error));
  }

  const root = ReactDOM.createRoot(document.getElementById(rootId));
  root.render(
    <Provider store={store}>
      <BomOptionsApp />
    </Provider>
  );
};

const saveForDesignLater = () => {
  dispatchBomOptionsSavingStartEvent(BomOptionsEventTargetDesignLater);

  store.dispatch(showWaitingCover());

  store.dispatch(
    addToCart({
      saveBomOptionsForDesignLater: true,
      onSaveBomOptionsSucceeded: (response) => {
        const cartItemId =
          !!response && !!response.data && !!response.data.cartIds && response.data.cartIds.length > 0
            ? response.data.cartIds[0]
            : 0;
        dispatchBomOptionsSavingCompletedEvent({
          cartItemId,
          target: BomOptionsEventTargetDesignLater,
        });
      },
    })
  );
};

window.promoStudio = window.promoStudio || {};
window.promoStudio = Object.assign({}, window.promoStudio, {
  bomOptions: {
    render,
    renderWithFullData,
    saveForDesignLater,
    bomColorChangeEvent: BomColorChangeEvent,
    bomOptionsErrorEvent: BomOptionsErrorEvent,
    bomOptionsLoadingCompletedEvent: BomOptionsLoadingCompletedEvent,
    bomOptionsSavingStartEvent: BomOptionsSavingStartEvent,
    bomOptionsSavingCompletedEvent: BomOptionsSavingCompletedEvent,
    bomOptionsValidationPassedEvent: BomOptionsValidationPassedEvent,
  },
});
